export default __webpack_public_path__ + "static/media/boss.689f0bbe.webp";